module.exports = __webpack_public_path__ + "img/clock5-01.b9fb621e.png";